/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_CATEGORY_DETAILS_REQUEST,
  FETCH_CATEGORY_DETAILS_SUCCESS,
  FETCH_CATEGORY_DETAILS_FAILURE,
} from "./CategoryTypes";

const initialState = {
  loading: false,
  categories: [],
  error: "",
};

const categoryDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CATEGORY_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_CATEGORY_DETAILS_SUCCESS:
      return {
        loading: false,
        categories: action.payload,
        error: "",
      };
    case FETCH_CATEGORY_DETAILS_FAILURE:
      return {
        loading: false,
        categories: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export default categoryDetailsReducer;
